import React from "react";
import "./productGrid.css";
import { useNavigate } from "react-router-dom";
import Wrapper from "../../../components/wrapper/Wrapper";
import TitleHeader from "../../../components/titleHeader/TitleHeader";

// ===== Icon set: one distinct icon per product category =====
const icons = {
  sprayGun: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 3l3 3-8 8-4 1 1-4 8-8z" />
      <path d="M17 6l1-1a2 2 0 0 1 3 3l-1 1" />
      <path d="M9 15l-4 4" />
      <path d="M5 19H3v-2" />
    </svg>
  ),
  particles: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="6" cy="6" r="1.5" fill="#fff" />
      <circle cx="12" cy="4" r="1.5" fill="#fff" />
      <circle cx="18" cy="7" r="1.5" fill="#fff" />
      <circle cx="9" cy="11" r="1.5" fill="#fff" />
      <circle cx="16" cy="13" r="1.5" fill="#fff" />
      <path d="M4 17c2-3 5-4 8-4s6 1 8 4" />
      <path d="M4 21c2-2 5-3 8-3s6 1 8 3" />
    </svg>
  ),
  blast: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" />
    </svg>
  ),
  oven: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="4" width="18" height="17" rx="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <circle cx="7" cy="6.5" r="0.8" fill="#fff" />
      <circle cx="10" cy="6.5" r="0.8" fill="#fff" />
      <rect x="6" y="12" width="12" height="6" rx="1" />
    </svg>
  ),
  factory: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 21V10l6 4v-4l6 4v-4l6 4v7H3z" />
      <line x1="3" y1="21" x2="21" y2="21" />
    </svg>
  ),
  droplet: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 2C8 7 5 11.5 5 15a7 7 0 0 0 14 0c0-3.5-3-8-7-13z" />
    </svg>
  ),
  paintShop: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 21V9l9-6 9 6v12" />
      <path d="M7 21v-7h10v7" />
      <path d="M9 14h6" />
      <path d="M9 17h6" />
      <path d="M12 3v3" />
    </svg>
  ),
};

const products = [
  {
    id: "0",
    img: require("../../../assets/images/product-grid/Paint Booth.jpg"),
    name: "Paint Booths",
    desc: "Advanced spray booths for perfect finish.",
    link: "/paint_booth",
    icon: icons.sprayGun,
  },
  {
    id: "1",
    img: require("../../../assets/images/product-grid/Powder Coating Booth.png"),
    name: "Powder Coating Booths",
    desc: "Efficient booths for superior powder application.",
    link: "/powder_coating_booth",
    icon: icons.particles,
  },
  {
    id: "2",
    img: require("../../../assets/images/product-grid/Shot Blasting Systems R.png"),
    name: "Shot Blasting Systems",
    desc: "Robust systems for surface preparation.",
    link: "/shot_blasting_system",
    icon: icons.blast,
  },
  {
    id: "3",
    img: require("../../../assets/images/product-grid/Industrial Oven.png"),
    name: "Industrial Ovens",
    desc: "Precision ovens for curing, drying & baking.",
    link: "/industrial_oven",
    icon: icons.oven,
  },
  {
    id: "4",
    img: require("../../../assets/images/product-grid/Powder Coating Plant.png"),
    name: "Powder Coating Plants",
    desc: "Reliable plants for high performance coating.",
    link: "/batch_type_powder_coating_plant",
    icon: icons.factory,
  },
  {
    id: "5",
    img: require("../../../assets/images/products/main-product/pre-t.jpeg"),
    name: "Pre Treatment Plants",
    desc: "Complete pre-treatment solutions for surfaces.",
    link: "/pre_treatment_plant",
    icon: icons.droplet,
  },
  {
    id: "6",
    img: require("../../../assets/images/product-grid/Paint Shop.jpeg"),
    name: "Paint Shop Project",
    desc: "Complete paint shop solutions for efficient industrial finishing.",
    link: "/paint_booth",
    icon: icons.paintShop,
  },
];

const ProductGrid = () => {
  const navigate = useNavigate();

  const handleTop = () => {
    window.scrollTo({ behavior: "smooth", top: 0 });
  };

  const handleNavigate = (link) => {
    navigate(link);
    handleTop();
  };

  return (
    <section className="stsg-main">
      <Wrapper>
        <TitleHeader
          headerMargin="1rem"
          title="Our Products"
          titleColor="#000"
          btnTitle="Products"
          btnTextColor="#1e1e1e"
          btnBgColor="rgb(192 192 192 / 34%)"
          btnIconColor="#fff"
          btnIconBgColor="#fff"
          isBtnVisible="N"
          isRightArrowVisible="N"
          rightArrowBgColor="#163C91"
          rightArrowIconColor="#fff"
        />

        <p data-aos="fade-up" className="stsg-description">
          At SURFTECHSYSTEMS INDIA PRIVATE LIMITED, we take pride in offering an
          extensive range of high-quality products designed to meet diverse
          industrial needs.
        </p>

        <div className="stsg-gallery">
          <div className="stsg-row stsg-row-four">
            {products.slice(0, 4).map((product) => (
              <article
                key={product.id}
                className="stsg-card"
                onClick={() => handleNavigate(product.link)}
              >
                <div className="stsg-img-wrap">
                  <img
                    src={product.img}
                    alt={product.name}
                    title={product.name}
                    loading="lazy"
                    decoding="async"
                    className="stsg-img"
                  />
                </div>

                <div className="stsg-icon-badge">{product.icon}</div>

                <div className="stsg-content">
                  <h5 className="stsg-title">{product.name}</h5>

                  <p className="stsg-desc">{product.desc}</p>

                  <span className="stsg-link">
                    VIEW PRODUCTS
                    <span className="stsg-link-arrow" aria-hidden="true">
                      &#8594;
                    </span>
                  </span>
                </div>
              </article>
            ))}
          </div>

          <div className="stsg-row stsg-row-three">
            {products.slice(4).map((product) => (
              <article
                key={product.id}
                className="stsg-card"
                onClick={() => handleNavigate(product.link)}
              >
                <div className="stsg-img-wrap">
                  <img
                    src={product.img}
                    alt={product.name}
                    title={product.name}
                    loading="lazy"
                    decoding="async"
                    className="stsg-img"
                  />
                </div>

                <div className="stsg-icon-badge">{product.icon}</div>

                <div className="stsg-content">
                  <h5 className="stsg-title">{product.name}</h5>

                  <p className="stsg-desc">{product.desc}</p>

                  <span className="stsg-link">
                    VIEW PRODUCTS
                    <span className="stsg-link-arrow" aria-hidden="true">
                      &#8594;
                    </span>
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </Wrapper>
    </section>
  );
};

export default ProductGrid;
